const random_alphabet = "23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz";
function random_char() {
	return random_alphabet[Math.floor(Math.random() * random_alphabet.length)];
}
function random_id(len) {
	if(!Number.isInteger(len) || len < 0) len = 17;
	var out = '';
	for(let i = 0; i < len; ++i) out += random_char();
	return out;
}

export default random_id;



// WEBPACK FOOTER //
// ./src/libs/randomIds.js